<template>
  <v-row>
    <v-col cols="9">
      <v-autocomplete
        full-width
        :items="places"
        :rules="[required]"
        :item-value="
          model.type === 'RST' && departurePlaces.length ? '_key' : 'short_name'
        "
        :item-text="item => `(${item.short_name}) ${item.stop_name}`"
        :filter="
          (item, query) =>
            item.short_name.toLowerCase().includes(query.toLowerCase()) ||
            item.stop_name.toLowerCase().includes(query.toLowerCase())
        "
        outlined
        label="Från"
        v-model="from"
      />
    </v-col>
    <v-col cols="3">
      <v-text-field
        :rules="[validTime]"
        v-model="time"
        type="time"
        label="Avgångstid"
        outlined
        :disabled="model.type === 'RST'"
      />
    </v-col>
  </v-row>
</template>

<script>
import { format } from 'date-fns'
import { get, sync } from 'vuex-pathify'
import { validDate, validTime } from '@/common/validationRules'
import { required } from '@/common/validationRules'

export default {
  name: 'TrainDeviationDeparture',

  data: () => ({
    required,
    validDate,
    validTime,
    date: null,
    time: null
  }),

  computed: {
    stops: get('event/stops'),
    from: sync('trainDeviation/model@from'),
    departure: get('trainDeviation/model@departure'),
    model: sync('trainDeviation/model'),
    departurePlaces: get('trainDeviation/departurePlaces'),

    places() {
      return this.model.type === 'RST' && this.departurePlaces.length
        ? this.departurePlaces
        : this.stops
    }
  },

  watch: {
    from: {
      handler(value) {
        if (
          !value ||
          this.model.type !== 'RST' ||
          !this.departurePlaces.length
        ) {
          this.time = format(new Date(this.departure), 'HH:mm')
          return
        }

        const [, advertised] = value.split('_')

        this.$store.set('trainDeviation/model@departure', new Date(advertised))
        this.time = format(new Date(advertised), 'HH:mm')
      },
      immediate: true
    },
    time(input) {
      if (this.model.type === 'RST') return
      const departureDate = format(new Date(this.departure), 'yyyy-MM-dd')
      const departure = new Date(`${departureDate} ${input}`)

      if (departure.getTime() < new Date(this.model.arrival).getTime()) {
        const arrivalTime = format(new Date(this.model.arrival), 'HH:mm')
        this.$store.set(
          'trainDeviation/model@arrival',
          new Date(`${departureDate} ${arrivalTime}`)
        )
      }

      this.$store.set('trainDeviation/model@departure', departure)
    }
  }
}
</script>
